import React, { useContext } from 'react'
import { updateReceivedPayments } from 'client/utils/api-routes.util'
import moment from 'moment'
import {
  DcButton,
  DcDiv,
  DcDropDown,
  DcInput,
  DcText,
  PixelFactoryContext,
} from 'pixel-base'
import styled from 'styled-components'
import {
  IPixelFactory,
  ICourierWithRiders,
  IDeliveryRecord,
} from '../../../../../decl.d'
interface IProps {
  payment: IDeliveryRecord
  couriers: ICourierWithRiders[]
  paymentID: string
}

const UpdateReceivedPayment = (props: IProps) => {
  const { showPageLoader, hidePageLoader, showSuccess, showFailure } =
    useContext<IPixelFactory>(PixelFactoryContext)
  const { payment, couriers, paymentID } = props
  const [error] = React.useState({
    error: '',
    field: '',
  })
  const [data, setData] = React.useState({
    courier_id: '',
    receiving_date: moment().format('YYYY-MM-DD'),
    amount: 0,
    invoice_reference: '',
    payment_gateway_id: '',
    bank_txn_ref: '',
    notes: '',
    weekly_payment_header_id: 1,
    courier_payment_id: paymentID,
  })

  React.useEffect(() => {
    setData({
      ...data,
      courier_id: payment.courier_id,
      receiving_date: moment(payment.date_bank_credited).format('YYYY-MM-DD'),
      amount: payment.amount,
      invoice_reference: payment.invoice_reference,
      payment_gateway_id: payment.payment_gateway_id,
      bank_txn_ref: payment.bank_txn_ref,
      notes: payment.payment_notes,
    })
  }, [payment])
  const handleSubmit = (e) => {
    e.preventDefault()
    showPageLoader()
    updateReceivedPayments(data).subscribe((res) => {
      hidePageLoader()
      if (res.response.data) {
        showSuccess('Payment Updated Successfully')
        props.handleClose(res.response.data)
      } else {
        showFailure(res.response.error)
        props.handleClose()
      }
    })
  }
  return (
    <>
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Courier
            </DcText>
            <DcDropDown
              error={
                error.field === 'courier_id' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              placeholder={'Select Courier'}
              options={[
                {
                  courier_name: 'Select Courier',
                  courier_id: '',
                },
                ...couriers,
              ]?.map((p) => {
                return {
                  label: p.courier_name,
                  value: p.courier_id,
                }
              })}
              value={data.courier_id}
              onChange={(e) => {
                setData({ ...data, courier_id: e.target.value })
              }}
            />
          </DcDiv>

          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Payment Receiving Date
            </DcText>
            <DcInput
              as="datePicker"
              error={
                error.field === 'receiving_date' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'Payment Receiving Date'}
              placeholder={'Payment Receiving Date'}
              value={data.receiving_date}
              onChange={(e) =>
                setData({
                  ...data,
                  receiving_date: moment(e).format('YYYY-MM-DD'),
                })
              }
            />
          </DcDiv>
        </FormGroup>
        <FormGroup>
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Invoice reference
            </DcText>
            <DcInput
              error={
                error.field === 'invoice_reference' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'invoice reference'}
              placeholder={'invoice reference'}
              value={data.invoice_reference}
              onChange={(e) =>
                setData({ ...data, invoice_reference: e.target.value })
              }
            />
          </DcDiv>

          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Amount
            </DcText>
            <DcInput
              error={
                error.field === 'amount' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'Amount'}
              placeholder={'Amount'}
              value={data.amount}
              onChange={(e) => setData({ ...data, amount: e.target.value })}
            />
          </DcDiv>
        </FormGroup>
        <FormGroup>
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Notes
            </DcText>
            <DcInput
              error={
                error.field === 'notes' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'Notes'}
              placeholder={'Notes'}
              value={data.notes}
              onChange={(e) => setData({ ...data, notes: e.target.value })}
            />
          </DcDiv>

          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Transaction Reference
            </DcText>
            <DcInput
              error={
                error.field === 'bank_txn_ref' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'Transaction Reference'}
              placeholder={'Transaction Reference'}
              value={data.bank_txn_ref}
              onChange={(e) =>
                setData({ ...data, bank_txn_ref: e.target.value })
              }
            />
          </DcDiv>
        </FormGroup>
        <FormGroup flexEnd>
          <DcButton variant="primary" type="submit">
            Save
          </DcButton>
        </FormGroup>
      </Form>
    </>
  )
}

const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  gap: 10px;
`

const FormGroup = styled.div<{ flexEnd?: boolean }>`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.flexEnd ? 'flex-end' : 'center')};
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
  flex-grow: 1;
  gap: 10px;
  .full-width {
    flex-grow: 1;
  }
`

export default UpdateReceivedPayment
